import React, { useState, useEffect, useRef } from 'react';

// Custom SVG Icons (kept from previous step)
const Icons = {
  Building: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 2H5c-1.1 0-2 .9-2 2v18h18V4c0-1.1-.9-2-2-2zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm0-4H5V5h2v2zm4 12H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm8 12h-6v-2h2v-2h-2v-2h2v-2h-2V9h6v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
    </svg>
  ),
  Users: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  Smile: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
      <line x1="9" y1="9" x2="9.01" y2="9"></line>
      <line x1="15" y1="9" x2="15.01" y2="9"></line>
    </svg>
  ),
  Ruler: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21.3 8.11 8.11 21.3a2.92 2.92 0 0 1-4.14 0 2.92 2.92 0 0 1 0-4.14L17.16 3.97a2.92 2.92 0 0 1 4.14 0 2.92 2.92 0 0 1 0 4.14Z"></path>
      <line x1="8" y1="16" x2="10" y2="18"></line>
      <line x1="11" y1="13" x2="13" y2="15"></line>
      <line x1="14" y1="10" x2="16" y2="12"></line>
      <line x1="17" y1="7" x2="19" y2="9"></line>
    </svg>
  )
};

const StatItem = ({ targetNumber, label, Icon, isVisible }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return; // Logic: Don't start if not visible

    let start = 0;
    const duration = 2000;
    const increment = targetNumber / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= targetNumber) {
        setCount(targetNumber);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [targetNumber, isVisible]);

  return (
    <div className="stat-card">
      <div className="stat-icon"><Icon /></div>
      <h2 className="stat-number">{count.toLocaleString()}</h2>
      <p className="stat-label">{label}</p>
    </div>
  );
};

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once it has played
        }
      },
      { threshold: 0.3 } // 30% of the section must be visible to trigger
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const stats = [
    { id: 1, target: 515, label: "Properties Operated", icon: Icons.Building },
    { id: 2, target: 138, label: "Amazing Team Members", icon: Icons.Users },
    { id: 3, target: 2493, label: "Happy Customers", icon: Icons.Smile },
    { id: 4, target: 18153396, label: "Total Sq. Ft.", icon: Icons.Ruler },
  ];

  return (
    <section className="stats-container" ref={sectionRef}>
      <div className="stats-overlay">
        <div className="stats-grid">
          {stats.map((stat) => (
            <StatItem 
              key={stat.id} 
              targetNumber={stat.target} 
              label={stat.label} 
              Icon={stat.icon} 
              isVisible={isVisible}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;